import { useCMSPageField } from '@/cms/fields'
import { mqMin, space, tokPx } from '@sunwebgroup/ui-components'
import { Rating, Typography } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'
import StandaloneReviewsScore from '../StandaloneReviewsScore'
import { Breadcrumb } from './Breadcrumb'

const PageHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: ${tokPx('semantics_layouts_max_width')};
  gap: ${space('primitives_space_8')};
  padding: 0 ${space('primitives_space_16')} ${space('primitives_space_16')} ${space('primitives_space_16')};
  margin: 0 auto;

  @media ${mqMin('primitives_breakpoint_m_min')} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: ${space('primitives_space_16')} ${space('primitives_space_32')};
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    padding: ${space('primitives_space_12')} ${tokPx('semantics_layouts_l_margin_left_and_right')} ${space('primitives_space_24')} ${tokPx('semantics_layouts_l_margin_left_and_right')};
  }
`

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space('primitives_space_4')};
`

const Title = styled(Typography)`
  ${Typography.modVariant('display-f-regular')}
  margin-right: ${space('primitives_space_16')};
  display: inline;

  @media ${mqMin('primitives_breakpoint_m_min')} {
    ${Typography.modVariant('display-e-regular')}
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    ${Typography.modVariant('display-c-regular')}
  }
`

const RatingStars = styled(Rating)`
  display: inline-block;
  vertical-align: super;
  position: relative;
  top: ${space('primitives_space_4')};
  white-space: nowrap;
`

export default function PDPHeading() {
  const rating = useCMSPageField('PDP.rating')
  const titleLabel = useCMSPageField('PDP.title')
  const shouldShowRating = rating !== 0

  return (
    <PageHeader>
      <HeaderWrapper>
        <div>
          <Title as="h1">{titleLabel}</Title>
          {shouldShowRating && <RatingStars rating={rating} />}
        </div>
        <Breadcrumb />
      </HeaderWrapper>
      <StandaloneReviewsScore />
    </PageHeader>
  )
}
